// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const InformationIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="InformationIcon" ref={forwardedRef} {...props}>
      <path d="M10.75 9v5h-1.5V9z" />
      <path d="M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-6.5-8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0" />
    </SvgIcon>
  );
});

/**
 * Use to give additional information
 * @public
 */
export const InformationIcon = /* @__PURE__ */ Object.assign(
  InformationIconComponent,
  { displayName: 'InformationIcon' },
);
